import paronApi from '@/utils/paron-api'

export default {
    // one page of the admin table: { page, perPage, filters: { search }, sortOption, order }
    getArticlesPage(options) {
        return paronApi.get(paronApi.listPath('article/all', options))
    },

    getAllArticles() {
        return paronApi.get('article/all')
    },

    getArticleById(id) {
        return paronApi.get(`article/${id}`)
    },

    createArticle(data) {
        return paronApi.post('article/new', data)
    },

    editArticleById(id, data) {
        return paronApi.post(`article/${id}/edit`, data)
    },

    deleteArticleById(id) {
        return paronApi.delete(`article/${id}`)
    }

}
